import { render, staticRenderFns } from "./question-answer-list.vue?vue&type=template&id=f8effacc&scoped=true&"
import script from "./question-answer-list.vue?vue&type=script&lang=js&"
export * from "./question-answer-list.vue?vue&type=script&lang=js&"
import style0 from "./question-answer-list.vue?vue&type=style&index=0&id=f8effacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8effacc",
  null
  
)

component.options.__file = "question-answer-list.vue"
export default component.exports